/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import FetchCountriesQuery from '../graphql/queries/FetchCountriesQuery.js';

const useFetchCountriesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(FetchCountriesQuery, args);

  return {
    error,
    loading,
    refetch,
    fetchCountries: R.omit(['__typename'], data?.fetchCountries_simulation_customer_grantees || {})
  };
};

export default useFetchCountriesQuery;
